import React, { Component } from 'react';

class About extends Component {
    constructor(props){
        super(props);
        this.state = {
            about: [
                {
                    id: 1,
                    icon: 'bi bi-badge2',
                    title: 'Perfil Profesional',
                    // Actualizado: "15 años" → "20 años" (CV)
                    text: 'Contadora pública con más de 20 años en finanzas públicas, fiscalización y hacienda municipal en los tres órdenes de gobierno.'
                },
                {
                    id: 2,
                    icon: 'bi bi-support',
                    title: 'Cargo Actual',
                    // Actualizado: texto genérico → cargo actual como Regidora (CV)
                    text: 'Regidora de Mineral de la Reforma e integrante de la Comisión Permanente de Hacienda, donde vigila el ejercicio del gasto público municipal.'
                },
                {
                    id: 3,
                    icon: 'bi bi-rocket2',
                    title: 'Logro Destacado',
                    // Actualizado: texto genérico → logro IMCO verificable (CV)
                    // TODO: confirmar enlace oficial del IMCO antes de publicar
                    text: 'Como Directora de Presupuesto en Pachuca de Soto, impulsó que el municipio pasara del lugar 89 al 7 nacional en el Índice de Información Presupuestal del IMCO.'
                }
            ]
        }
    }
    render() {
        return (
        <section className="about-section section-padding bg-grey" id="about">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-6">
                        <div className="about-img">
                            {/* Actualizado: "booke.jpg" (roto) → "marlene-about.jpeg" */}
                            <img src="assets/images/banner/marlene-about.jpeg" alt="Marlene Puertas Ramírez" className="img-fluid"/>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <div className="section-heading">
                            <span className="subheading">Acerca de </span>
                            <h3 className="heading-title">Experiencia en Administración Pública</h3>
                            <p>Profesional con amplia experiencia en contabilidad y administración pública. Mi carrera abarca roles críticos en la gestión financiera de los gobiernos municipales y capacidades de asesoría.</p>
                        </div>

                        {
                            this.state.about.map((data,i) => (
                                <div className="about-text-block" key={i}>
                                    <i className={data.icon}></i>
                                    <h4>{data.title}</h4>
                                    <p>{data.text} </p>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </section>  
        );
    }
}

export default About;
